import { Box } from "@mui/material";
import ComingSoonGif from "../../../../assets/coming-soon.gif";
import TitleSection from "../../../../components/titleSection/TitleSection";

export default function BlogSection() {
  return (
    <Box>
      <TitleSection title="Blog" />
      <Box
        sx={{
          justifyContent: "center",
          display: "flex",
          alignItems: "center",
          height: 300,
        }}
      >
        <img src={ComingSoonGif} alt="coming soon gif" />
      </Box>
    </Box>
  );
}
